import { render, staticRenderFns } from "./StatueView.vue?vue&type=template&id=08b9b54b"
import script from "./StatueView.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatueView.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports